import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Brand, LangSwitch } from "@/components/Shell";
import { useT } from "@/i18n";
import { ROLE_HOME, errMsg } from "@/lib/api";

export function AuthCard({ title, subtitle, children, footer }) {
  const { t } = useT();
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-ink grain overflow-hidden">
        <img src="/img/hero-team.jpg" alt="La squadra Ci penso io" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="relative p-12 flex flex-col h-full justify-between text-white">
          <Brand dark />
          <div><p className="eyebrow !text-amber-300">Ci penso io</p><h2 className="mt-3 font-serif text-4xl font-semibold leading-tight max-w-md">{t("brand.payoff")}</h2></div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md rise">
          <div className="flex items-center justify-between mb-8"><span className="lg:hidden"><Brand /></span><span className="ml-auto"><LangSwitch /></span></div>
          <h1 className="font-serif text-4xl font-bold">{title}</h1>
          <p className="mt-2 text-sm text-ink/60">{subtitle}</p>
          <div className="mt-8">{children}</div>
          <div className="mt-6 text-sm text-ink/60">{footer}</div>
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const { login } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const u = await login(form.email, form.password); nav(sp.get("next") || ROLE_HOME[u.role]); }
    catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <AuthCard title={t("auth.welcome")} subtitle={t("auth.loginSub")} footer={<>{t("auth.noAccount")} <Link to="/register" className="text-terracotta font-semibold" data-testid="go-register-link">{t("nav.register")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div><label className="label-craft">{t("common.email")}</label><input data-testid="login-email-input" className="input-craft" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
        <div><label className="label-craft">{t("common.password")}</label><input data-testid="login-password-input" className="input-craft" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
        <button data-testid="login-submit-button" className="btn-primary w-full" disabled={busy}>{busy ? t("auth.signingIn") : t("nav.login")}</button>
      </form>
    </AuthCard>
  );
}
